import React from 'react'
import {Navigate} from 'react-router-dom'
import {BASE_ROUTES, SIDEBAR_ROUTES} from '~/src/routes/constants'
import {useVisibleSettingsPages} from './settingsPages'

/**
 * /settings lands on the first Settings page the user may open, in menu order (settingsPages.ts).
 *
 * STFFLG-4185: with none, the notification inbox, never a Settings page. Work Authorization used to
 * be the catch-all because it had no permission; it now has its own matrix row, so it can be the
 * one page a user is denied, and every bell user can open the inbox. A layout with no bell (Company)
 * has no inbox either, so a Company role holding no Settings page is told it is unauthorized rather
 * than sent to a path its layout does not serve (the not-found page).
 *
 * No role in the store at all (sign-in stored none) is never "still loading": redux-persist has
 * rehydrated before the first render, so waiting would leave /settings blank for good. Such a user
 * reads every row as absent, so it lands on Work Authorization like any other role without rows.
 */
const SettingsRedirect: React.FC = () => {
  const {pages, hasInbox} = useVisibleSettingsPages()

  // Absolute targets (STFFLG-3995, see routeConfig): this renders on the flat 'settings' route, so a
  // relative 'settings/documents/files' resolved to /settings/settings/documents/files, a 404.
  const fallback = hasInbox ? SIDEBAR_ROUTES.NOTIFICATIONS : BASE_ROUTES.UNAUTHORIZED
  const target = pages[0] ? `/${pages[0].path}` : fallback
  return <Navigate to={target} replace />
}

export default SettingsRedirect
